<template>
  <div>
    <vs-button
      color="#32C040"
      icon="add_box"
      style="border-radius: 20px; width: 20%"
      v-b-modal.starWO
    >
      Start Work Order
    </vs-button>
    <b-modal id="starWO" centered size="lg" title="Setup Work Order">
      <template #modal-header-close>
        <vs-button
          icon="close"
          style="border-radius: 20px"
          color="red"
        ></vs-button>
      </template>
      <template>
        <vs-row
          ><vs-spacer />
          <vs-button
            icon="space_dashboard"
            style="border-radius: 20px"
            class="mr-2"
            v-b-modal.Templates
            >Templates</vs-button
          ></vs-row
        >
        <vs-row vs-w="12">
          <vs-col vs-lg="4">
            <vs-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              @on-success="successUpload"
              limit="1"
          /></vs-col>
          <vs-col vs-lg="4">
            <p class="mt-2">Work Order Name</p>
            <div>
              <vs-input class="inputx" v-model="value1" style="width: 120%" />
            </div>

            <p class="mt-2">Due Date</p>
            <div>
              <datetime
                format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                class="ml-1"
              />
            </div>
          </vs-col>
        </vs-row>
        <br />
        <vs-row style="justify-content: center">
          <p class="mt-2 mr-4">Type:</p>

          <div class="mr-5 mt-2">
            <vs-radio
              style="justify-content: unset"
              v-model="radios1"
              vs-name="radios1"
              vs-value="true"
            >
              Planned
            </vs-radio>

            <vs-radio
              v-model="radios1"
              vs-name="radios1"
              style="justify-content: unset"
              vs-value="false"
            >
              Unplanned
            </vs-radio>
          </div>

          <p class="mt-2 mr-4">Priority :</p>
          <vs-select v-model="selectpriority">
            <vs-select-item
              v-for="(item, index) in priority"
              :key="index"
              :value="item.value"
              :text="item.text"
              class="ignore-css"
            >
            </vs-select-item>
          </vs-select>
        </vs-row>
        <br />
        <vs-row>
          <vs-spacer />
          <vs-input
            class="mr-3"
            icon-after="true"
            icon="search"
            placeholder="What are you looking for?"
            v-model="value1"
          />
        </vs-row>
        <br />
        <vs-row vs-w="12">
          <vs-col vs-lg="6"
            ><p>Teams :</p>
            <vs-card
              v-for="(item, index) in 4"
              :key="index"
              actionable
              class="carduser"
            >
              <vs-row>
                <vs-icon icon="groups"></vs-icon>
                <p class="mt-1 ml-3">Chisten Eva</p>
                <vs-spacer></vs-spacer>
                <vs-icon icon="delete" color="red"></vs-icon>
              </vs-row>
            </vs-card>
          </vs-col>
          <vs-col vs-lg="6"
            ><p>Users :</p>
            <vs-card
              v-for="(item, index) in 4"
              :key="index"
              actionable
              class="carduser"
            >
              <vs-row>
                <vs-icon icon="person"></vs-icon>
                <p class="mt-1 ml-3">Chisten Eva</p>
                <vs-spacer></vs-spacer>
                <vs-icon icon="delete" color="red"></vs-icon>
              </vs-row>
            </vs-card>
          </vs-col>
        </vs-row>
      </template>
      <template #modal-footer>
        <vs-row>
          <a href="#" v-b-modal.setupteam>Set up a Team</a>
          <vs-spacer></vs-spacer>
          <vs-button style="border-radius: 20px; width: 15%"
            >Start Work Order</vs-button
          >
        </vs-row>
      </template>
    </b-modal>
    <b-modal id="setupteam" centered size="lg" title="Manage Teams">
      <template #modal-header-close>
        <vs-button
          icon="close"
          style="border-radius: 20px"
          color="red"
        ></vs-button>
      </template>
      <template>
        <vs-row>
          <vs-icon icon="person" size="40px"></vs-icon>
          <vs-input
            class="mt-1 ml-2"
            placeholder="Users"
            v-model="value1"
            style="width: 15%; text-align: center"
            disabled
          />
          <vs-spacer></vs-spacer>
          <vs-input
            icon-after="true"
            icon="search"
            placeholder="What are you looking for?"
            v-model="value1"
          />
        </vs-row>
        <br />
        <p>Below is a list of your users and their teams.</p>
        <br />
        <vs-divider />
        <br />
        <vs-row>
          <vs-icon icon="groups" size="40px"></vs-icon>
          <vs-input
            class="mt-1 ml-2"
            placeholder="Teams"
            v-model="value1"
            style="width: 15%; text-align: center"
            disabled
          />
          <vs-icon
            icon="add_circle"
            color="primary"
            class="mt-2 ml-2"
          ></vs-icon>
          <vs-spacer></vs-spacer>
          <vs-input
            icon-after="true"
            icon="search"
            placeholder="What are you looking for?"
            v-model="value1"
          />
        </vs-row>
        <br />
        <p>Below is a list of your Teams for this locations.</p>
        <br />
      </template>
    </b-modal>
    <b-modal
      id="Templates"
      centered
      size="lg"
      title="Work Order Templates"
      scrollable
    >
      <template #modal-header-close>
        <vs-button icon="close" style="border-radius: 20px" color="red" />
      </template>
      <template>
        <vs-row>
          <vs-spacer />
          <vs-input
            icon-after="true"
            icon="search"
            placeholder="What are you looking for?"
            v-model="value1"
          />
        </vs-row>
        <br />
        <vs-collapse v-for="item in 7" :key="item" style="margin-bottom: -30px">
          <vs-collapse-item>
            <div slot="header" class="divcard">
              <br />
              <vs-row>
                <vs-icon
                  icon="folder"
                  color="dark"
                  size="30px"
                  class="ml-2"
                ></vs-icon>
                <p class="ml-3 mt-2">WO{{ item }}</p>
              </vs-row>
            </div>
            <vs-card class="cardshadow ml-5" @click="this.cardcolor = red"
              >test2</vs-card
            >
          </vs-collapse-item>
        </vs-collapse>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    priority: Array,
  },
  data() {
    return {
      radios1: "true",
    };
  },
};
</script>

<style scoped lang="scss">
.divcard {
  height: 50px;
  border-radius: 5px;
  box-shadow: 1px 1px 5px 0px grey;
}
.cardshadow {
  margin-bottom: -10px;
  box-shadow: 1px 1px 5px 0px grey;
  width: 93.5%;
}
.carduser {
  margin-bottom: 10px;
  border-radius: 10px;
}
</style>
<style>
.divcard {
  height: 50px;
  border-radius: 5px;
  box-shadow: 1px 1px 5px 0px grey;
}
.cardshadow {
  margin-bottom: -10px;
  box-shadow: 1px 1px 5px 0px grey;
  width: 93.5%;
}
</style>
